module.exports = __webpack_public_path__ + "img/discover_icon.fcb847cf.png";